<template>
  <v-dialog v-model="dialogModel" width="350" @click:outside="emit('update:show', false)" @keydown.esc="emit('update:show', false)">
    <v-card style="border-radius: 12px" class="bg-white px-4 py-8">
      <div class="d-flex justify-center mb-4">
        <svg :key="uniqueId" width="270" height="158" viewBox="0 0 270 158" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
          <rect width="270" height="158" fill="white"/>
          <rect width="109.659" height="109.659" transform="translate(80.5991 21.5)" fill="white"/>
          <g :filter="`url(#filter0_${uniqueId})`" class="rotating-background">
            <circle cx="135.313" cy="76.1039" r="54.3484" transform="rotate(58.73 135.313 76.1039)" :fill="`url(#paint0_${uniqueId})`"/>
          </g>
          <g :filter="`url(#filter1_${uniqueId})`" class="rotating-background-reverse">
            <path d="M129.398 53.821C146.725 49.1782 162.58 65.0336 157.937 82.3607C153.294 99.6877 131.636 105.491 118.951 92.8069C106.267 80.1226 112.07 58.4637 129.398 53.821Z" :fill="`url(#paint1_${uniqueId})`"/>
          </g>
          <path class="star star-large" d="M140.551 76.4129C140.69 75.8608 141.474 75.8608 141.614 76.4129L141.864 77.4029C142.6 80.3178 145.015 82.5432 147.972 83.0835C148.572 83.1931 148.572 84.0627 147.972 84.1723C145.015 84.7126 142.6 86.938 141.864 89.853L141.614 90.8429C141.474 91.395 140.69 91.395 140.551 90.8429L140.301 89.853C139.565 86.938 137.15 84.7126 134.192 84.1723C133.593 84.0627 133.593 83.1931 134.192 83.0835C137.15 82.5432 139.565 80.3178 140.301 77.4029L140.551 76.4129Z" :fill="`url(#paint2_${uniqueId})`"/>
          <path class="star star-small" d="M135.766 58.9438C135.819 58.4912 136.476 58.4912 136.529 58.9438L136.593 59.4973C136.79 61.1916 138.082 62.5526 139.763 62.838L140.497 62.9625C140.923 63.0348 140.923 63.647 140.497 63.7193L139.763 63.8439C138.082 64.1292 136.79 65.4903 136.593 67.1846L136.529 67.738C136.476 68.1907 135.819 68.1907 135.766 67.7381L135.702 67.1846C135.505 65.4903 134.213 64.1292 132.532 63.8439L131.798 63.7193C131.372 63.647 131.372 63.0348 131.798 62.9625L132.532 62.838C134.213 62.5526 135.505 61.1916 135.702 59.4973L135.766 58.9438Z" :fill="`url(#paint3_${uniqueId})`"/>
          <defs>
            <filter :id="`filter0_${uniqueId}`" x="62.167" y="2.95751" width="146.293" height="146.293" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
              <feGaussianBlur stdDeviation="9.39502" :result="`effect1_foregroundBlur_${uniqueId}`"/>
            </filter>
            <filter :id="`filter1_${uniqueId}`" x="98.0193" y="38.9097" width="74.8294" height="74.8294" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
              <feGaussianBlur stdDeviation="7.04627" :result="`effect1_foregroundBlur_${uniqueId}`"/>
            </filter>
            <linearGradient :id="`paint0_${uniqueId}`" x1="92.2004" y1="29.2458" x2="168.062" y2="130.452" gradientUnits="userSpaceOnUse">
              <stop stop-color="#9100FF"/>
              <stop offset="1" stop-color="#008CFF" stop-opacity="0"/>
            </linearGradient>
            <linearGradient :id="`paint1_${uniqueId}`" x1="168.384" y1="43.3747" x2="102.474" y2="109.284" gradientUnits="userSpaceOnUse">
              <stop offset="0.23" stop-color="#9900FF" stop-opacity="0.75"/>
              <stop offset="1" stop-color="#0022FF" stop-opacity="0"/>
            </linearGradient>
            <linearGradient :id="`paint2_${uniqueId}`" x1="141.082" y1="74.0062" x2="141.082" y2="93.2496" gradientUnits="userSpaceOnUse">
              <stop stop-color="#CDFF3D"/>
              <stop offset="0.22" stop-color="white"/>
              <stop offset="1" stop-color="#FF9900"/>
            </linearGradient>
            <linearGradient :id="`paint3_${uniqueId}`" x1="136.147" y1="56.7614" x2="136.147" y2="69.9205" gradientUnits="userSpaceOnUse">
              <stop stop-color="#CDFF3D"/>
              <stop offset="0.22" stop-color="white"/>
              <stop offset="1" stop-color="#FF9900"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="d-flex flex-column items-center">
        <span class="ai-dialog-title">
          Generating with AI
        </span>
        <span class="ai-dialog-text">
          {{ text }}
        </span>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
// Global counter for unique IDs (outside setup to persist across instances)
let idCounter = 0;
</script>

<script setup>
import { computed, ref, watch } from "vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: "Analyzing Role and identifying Responsibilities and Checklists for it…"
  }
});

const emit = defineEmits(["update:show"]);

// Generate unique ID for this instance to avoid SVG conflicts
// Regenerate ID each time the dialog is shown to ensure uniqueness
const uniqueId = ref(`ai_${++idCounter}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`);

// Regenerate unique ID whenever dialog is shown
watch(() => props.show, (newValue) => {
  if (newValue) {
    uniqueId.value = `ai_${++idCounter}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
});

const dialogModel = computed({
  get: () => props.show,
  set: (value) => {
    emit("update:show", value);
  }
});
</script>

<style scoped>
.ai-dialog-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
  color: #101828;
  position: relative;
  overflow: hidden;
}
.ai-dialog-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: #666666;
  position: relative;
  overflow: hidden;
}
.ai-dialog-title::before, .ai-dialog-text::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 50%,
      rgba(255, 255, 255, 0) 100%
  );
  animation: loadingShine 1.5s infinite;
}

.rotating-background {
  transform-origin: 135.313px 76.1039px;
  animation: rotate 3s linear infinite;
}

.rotating-background-reverse {
  transform-origin: 135.433px 76.3245px;
  animation: rotate-reverse 3s linear infinite;
}

.star-large {
  animation: pulse-large 1.5s ease-in-out infinite;
  transform-origin: 141.082px 83.6279px;
}

.star-small {
  animation: pulse-small 1.5s ease-in-out infinite;
  transform-origin: 136.147px 63.3409px;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotate-reverse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes pulse-large {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(0);
  }
}

@keyframes pulse-small {
  0%, 100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}

@keyframes loadingShine {
  to {
    left: 150%;
  }
}
</style>